import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";

export default function MobileTabNav({ level, handlePostNavTab, tab }) {
  return (
    <div style={{ overflowX: "scroll", whiteSpace: "nowrap" }}>
      <Nav tabs className="bg-primary" style={{ display: "inline-block" }}>
        <NavItem
          style={{ display: "inline-block" }}
          onClick={() => handlePostNavTab(1)}
        >
          <NavLink className={tab === 1 ? "active text-primary" : "text-white"}>
            <FontAwesomeIcon icon="map" />
            &nbsp; <FormattedMessage id="Admin" />
          </NavLink>
        </NavItem>
        <NavItem
          style={{ display: "inline-block" }}
          onClick={() => handlePostNavTab(2)}
        >
          <NavLink className={tab === 2 ? "active text-primary" : "text-white"}>
            <FontAwesomeIcon icon="book-open" />
            &nbsp; <FormattedMessage id="Courses" />
          </NavLink>
        </NavItem>

        <NavItem
          style={{ display: "inline-block" }}
          onClick={() => handlePostNavTab(3)}
        >
          <NavLink className={tab === 3 ? "active text-primary" : "text-white"}>
            <FontAwesomeIcon icon="chart-pie" />
            &nbsp; <FormattedMessage id="ResultsOverview" />
          </NavLink>
        </NavItem>
        {level === "class" ? (
          <>
            <NavItem
              style={{ display: "inline-block" }}
              onClick={() => handlePostNavTab(5)}
            >
              <NavLink
                className={tab === 5 ? "active text-primary" : "text-white"}
              >
                <FontAwesomeIcon icon="chalkboard-teacher" />
                &nbsp;
                <FormattedMessage id="Documents" />
              </NavLink>
            </NavItem>
          </>
        ) : (
          ""
        )}
        <NavItem
          style={{ display: "inline-block" }}
          onClick={() => handlePostNavTab(7)}
        >
          <NavLink className={tab === 7 ? "active text-primary" : "text-white"}>
            <FontAwesomeIcon icon="briefcase" />
            &nbsp; <FormattedMessage id="APL" />
          </NavLink>
        </NavItem>
      </Nav>
    </div>
  );
}
